<template>
  <v-layout
    row
    justify-center
  >
    <v-flex xs7>
      <v-form
        ref="form"
        class="pr-4"
      >
        <v-text-field
          v-model="locationName"
          :rules="[ v => !!v || 'Location Name is required']"
          label="Location Name"
          hint="Name of the location you want to deploy kiosk(s). eg. (HQ - Residency Road)"
          persistent-hint
          required
          @blur="updateParent"
        />
        <v-text-field
          v-model="companyName"
          :rules="[ v => !!v || 'Company Name is required']"
          class="pt-3"
          label="Company Name"
          @blur="updateParent"
        />
        <v-text-field
          id="autocomplete"
          v-model="locationObj.address"
          label="Address"
          @blur="onBlur()"
        />
      </v-form>
    </v-flex>
    <div
      id="maxMap"
      ref="maxTowersMap"
      class="google-map"
    />
  </v-layout>
</template>
<script>
export default {
  name: 'Location',
  props: {
    location: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      locationObj: {},
      autocomplete: {},
      map: null,
      marker: null,
      autocompletedAddress: false
    };
  },
  computed: {
    locationName: {
      get() {
        return this.locationObj.locationName;
      },
      set(value) {
        this.locationObj.locationName = value.trim();
      }
    },
    companyName: {
      get() {
        return this.locationObj.companyName;
      },
      set(value) {
        this.locationObj.companyName = value.trim();
      }
    }
  },
  watch: {
    location: {
      handler(val) {
        if (!val) return;
        this.locationObj = val;
        this.drawMarker();
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    const autocompleteElement = document.getElementById('autocomplete');
    autocompleteElement.placeholder = '';
    this.autocomplete = new google.maps.places.Autocomplete(
      autocompleteElement,
      {}
    );

    this.autocomplete.addListener('place_changed', () => {
      const place = this.autocomplete.getPlace();
      this.autocompletedAddress = true;
      if (place.geometry.viewport) {
        this.map.fitBounds(place.geometry.viewport);
      } else {
        this.map.setCenter(place.geometry.location);
        this.map.setZoom(17); // Why 17? Because it looks good.
      }

      this.locationObj.address = `${place.name}, ${place.formatted_address}`;
      this.locationObj.latitude = place.geometry.location.lat();
      this.locationObj.longitude = place.geometry.location.lng();
      this.marker.setMap(null);
      this.drawMarker();
      this.updateParent();
    });
  },
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
    updateParent() {
      this.$emit('change', this.locationObj);
    },

    drawMarker() {
      this.$nextTick().then(() => {
        const element = this.$refs.maxTowersMap;
        if (!element) return;
        const mapCentre = this.locationObj;
        const options = {
          zoom: 17,
          center: new google.maps.LatLng(
            mapCentre.latitude,
            mapCentre.longitude
          ),
          disableDefaultUI: true
        };
        /* global google */
        this.map = new google.maps.Map(element, options);
        const position = new google.maps.LatLng(
          this.locationObj.latitude,
          this.locationObj.longitude
        );
        this.marker = new google.maps.Marker({
          position,
          map: this.map
        });
      });
    },
    onBlur() {
      const val = this.locationObj.address;
      const geocoder = new google.maps.Geocoder();
      geocoder.geocode({ address: val }, (results, status) => {
        if (status === google.maps.GeocoderStatus.OK) {
          const lat = results[0].geometry.location.lat();
          const long = results[0].geometry.location.lng();
          this.locationObj.latitude = lat;
          this.locationObj.longitude = long;
          this.marker.setMap(null);
          this.map.setCenter(new google.maps.LatLng(lat, long));
          this.map.setZoom(17);
          this.drawMarker();
          this.updateParent();
        }
      });
    }
  }
};
</script>
<style>
.google-map {
  width: 500px;
  height: 300px;
  background: gray;
}
</style>

